// extracted by mini-css-extract-plugin
export default {"container":"SearchModal_container__ao7G5"};